(() => {
  if (window.__PPU_INIT__) return
  window.__PPU_INIT__ = true

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true })
    } else {
      fn()
    }
  }

  function formatMoneyAmount(cents) {
    let s = ''
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      s = Shopify.formatMoney(cents)
    } else {
      const sym = typeof window.__CURRENCY_SYMBOL__ === 'string' ? window.__CURRENCY_SYMBOL__ : '$'
      s = `${sym}${(cents / 100).toFixed(2)}`
    }

    return String(s).replace(/\b[A-Z]{3}\b/g, '').replace(/\s+/g, ' ').trim()
  }

  function getVariantFromGlobal(variantId) {
    const list = window.allVariants || []
    return list.find((v) => String(v.id) === String(variantId)) || null
  }

  window.currentVariantId = window.currentVariantId || null

  function setPriceText(el, moneyText) {
    if (!el) return
    const inner = el.querySelector?.('.js-price-value')
    if (inner) {
      inner.textContent = moneyText
      return
    }
    el.textContent = moneyText
  }

  function readCurrentVariantIdFromDom() {
    const variantInput =
      document.querySelector('input[name="id"][type="hidden"]') ||
      document.querySelector('select[name="id"]') ||
      document.querySelector('input[name="id"]:checked')

    return variantInput?.value ? String(variantInput.value) : null
  }

  // --- debounce helper ---
  function makeDebounced(fn, wait) {
    let t = null
    return function debounced(...args) {
      if (t) clearTimeout(t)
      t = setTimeout(() => fn.apply(this, args), wait)
    }
  }

  window.updatePrices = function updatePrices(variantId) {
    window.currentVariantId = String(variantId)

    const priceElement = document.getElementById('main-price')
    const compareAtElement = document.getElementById('compare-at-price')
    const discountPercentElement = document.getElementById('discount-percentage')
    const discountWrap = document.querySelector('.discount_price_wrap')
    const limitedTimeTag = document.querySelector('.limited_time_tag')

    const salePriceElList = document.querySelectorAll('.price--on-sale .price-item--sale')
    const regularPriceElList = document.querySelectorAll('.price--on-sale s.price-item--regular')
    const saleBadgePercent = document.querySelectorAll('.sale_badge_percent')

    setTimeout(() => {
      const variant = getVariantFromGlobal(variantId)
      if (!variant) return

      const moneyText = formatMoneyAmount(variant.price)

      function setPriceInEl(el, formatted) {
        if (!el) return
        const val = el.querySelector?.('.js-price-value')
        if (val) {
          val.textContent = formatted
        } else {
          el.textContent = formatted
        }
      }

      // Main price 
      setPriceInEl(priceElement, moneyText)
      salePriceElList.forEach((el) => setPriceInEl(el, moneyText))

      // Compare-at + sale
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (discountWrap) discountWrap.style.display = ''
        if (limitedTimeTag) limitedTimeTag.style.display = ''

        const compareText = formatMoneyAmount(variant.compare_at_price)

        if (compareAtElement) setPriceText(compareAtElement, compareText)
        regularPriceElList.forEach((el) => (el.textContent = compareText))

        const discountPercentage = Math.round(
          ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price,
        )

        if (discountPercentElement) {
          discountPercentElement.textContent = `-${discountPercentage}% OFF`
        }
        saleBadgePercent.forEach((el) => (el.textContent = String(discountPercentage)))
      } else {
        if (discountWrap) discountWrap.style.display = 'none'
        if (limitedTimeTag) limitedTimeTag.style.display = 'none'
      }
    }, 50)
  }

  function bindVariantChangeListeners() {
    const shouldHandle = (target) => {
      if (!target) return false
      return (
        target.matches?.('select[name="id"]') ||
        target.matches?.('input[name="id"]') ||
        target.matches?.('input[name="id"][type="hidden"]') ||
        target.matches?.('select[name^="options"]') ||
        target.matches?.('input[name^="options"]') ||
        target.matches?.('.single-option-selector') ||
        target.matches?.('[data-option-selector]') ||
        target.matches?.('.swatch-element input') ||
        target.matches?.('.color-swatch-wrapper input')
      )
    }

    const runUpdate = makeDebounced(() => {
      const id = readCurrentVariantIdFromDom()
      if (id) window.updatePrices(id)
    }, 80)

    document.addEventListener(
      'change',
      (e) => {
        if (shouldHandle(e.target)) runUpdate()
      },
      true,
    )

    document.addEventListener(
      'input',
      (e) => {
        if (shouldHandle(e.target)) runUpdate()
      },
      true,
    )

    document.addEventListener(
      'click',
      (e) => {
        const t = e.target
        if (shouldHandle(t) || t?.closest?.('.swatch-element, .color-swatch-wrapper, [data-option-selector]')) {
          runUpdate()
        }
      },
      true,
    )

    const productForm = document.querySelector('form[action*="/cart/add"]')
    if (productForm) {
      const observer = new MutationObserver(() => runUpdate())
      observer.observe(productForm, { attributes: true, childList: true, subtree: true })
    }

    // Shopify-ish events
    document.addEventListener('variant:change', (event) => {
      const id = event?.detail?.variant?.id
      if (id) window.updatePrices(id)
    })

    if (typeof jQuery !== 'undefined') {
      jQuery(document).on('variant:change variantChange', (event, variant) => {
        if (variant?.id) window.updatePrices(variant.id)
      })
    }

    document.addEventListener('appstle:subscription:changed', () => {
      const id = window.currentVariantId || readCurrentVariantIdFromDom()
      if (id) window.updatePrices(id)
    })

    document.addEventListener('sellingplan:changed', () => {
      const id = window.currentVariantId || readCurrentVariantIdFromDom()
      if (id) window.updatePrices(id)
    })

    let lastId = null
    setInterval(() => {
      const id = readCurrentVariantIdFromDom()
      if (id && id !== lastId) {
        lastId = id
        window.updatePrices(id)
      }
    }, 300)
  }

  onReady(async () => {
    if (window.__variantsPromise__) await window.__variantsPromise__
    bindVariantChangeListeners()

    const initialId = readCurrentVariantIdFromDom()
    if (initialId) window.updatePrices(initialId)
  })
})()